export default "__VITE_ASSET__7p6JqaVF__"